module.exports = __webpack_public_path__ + "static/img/invoiceTemplate.a32bf7d2.jpg";